import {createAsyncThunk} from '@reduxjs/toolkit';

import {showMessageFromResponse} from 'shared/utils';
import {IEtlAuditTableData, ETL_SLICE} from 'store/slices/etl-slice';

import {fetchEtlAuditData} from './api';

export const loadEtlAudit = createAsyncThunk<
    IEtlAuditTableData, Record<string, string | number | undefined>
>(
    `${ETL_SLICE}/loadEtlAudit`,
    async (args, {rejectWithValue}) => {
        try {
            const {data: etlData} = await fetchEtlAuditData(args);

            return etlData;
        } catch (e) {
            showMessageFromResponse({response: e.response, isError: true});
            return rejectWithValue({});
        }
    },
);
